import { LabelProps } from 'recharts';
import React from 'react';

// Sometimes, labels were clipped because of the position and size of the bars
// So we need to add a little configuration based in height
export function AmountLabel(props: LabelProps & { unit?: string; }) {
  const {
    x = 0, y = 0, width = 0, height = 0, value, viewBox, unit,
  } = props;
  // Type assertion is required because `viewBox` can be undefined, but we always
  // expect it to be an object with a `width` property.
  const isSmall = Math.abs((viewBox as { width: number }).width) < 16;
  const isNegative = +width < 0;
  const fill = isSmall ? '#000' : '#fff';
  const yCenter = +height / 2;
  const textX = isNegative
    ? +width * 0.5
    : +width - +width * 0.5;

  if (isSmall) {
    const offset = 8;
    const outsideX = isNegative ? +width - offset : +width + offset;
    return (
      <g transform={`translate(${x}, ${y})`}>
        <text
          y={yCenter}
          x={outsideX}
          dominantBaseline="middle"
          fontSize={11}
          fill="#000"
          textAnchor={isNegative ? 'end' : 'start'}
        >
          {value}
          <tspan fontSize={10}>{unit}</tspan>
        </text>
      </g>
    );
  }

  return (
    <g transform={`translate(${x}, ${y})`}>
      <text
        y={yCenter}
        x={textX}
        dominantBaseline="middle"
        fontSize={11}
        fill={fill}
        textAnchor="middle"
      >
        {value}
        <tspan fontSize={10}>{unit}</tspan>
      </text>
    </g>
  );
}
